import { type DeviceEventsClient, type DeviceEventsInitOptions } from '../types/deviceEvents.type';
import { trackDeviceEventInFullStory } from './deviceEventsFullStory.util';
import { clearTrackCallback, registerTrackCallback } from './deviceEventsPublisher.util';
import { createDeviceEventsReporter } from './deviceEventsReporter.util';

let activeReporter: ReturnType<typeof createDeviceEventsReporter> | null = null;

export const teardownDeviceEvents = (): void => {
  clearTrackCallback();
  activeReporter?.dispose();
  activeReporter = null;
};

export const initDeviceEvents = (
  client: DeviceEventsClient,
  options?: DeviceEventsInitOptions,
): ReturnType<typeof createDeviceEventsReporter> => {
  teardownDeviceEvents();

  const reporter = createDeviceEventsReporter(client, options);
  activeReporter = reporter;
  registerTrackCallback((event) => {
    reporter.track(event);
    trackDeviceEventInFullStory(event);
  });

  return reporter;
};
